"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildForm = void 0;
var legup_model_1 = require("@legup/legup-model");
var react_1 = __importDefault(require("react"));
var Address_1 = require("../common/Address");
var Alert_1 = require("../common/Alert");
var ChooseDate_1 = require("../common/ChooseDate");
var LimitTextField_1 = require("../common/LimitTextField");
var strings_1 = __importDefault(require("../strings"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var Select_1 = __importDefault(require("@material-ui/core/Select"));
var styles_1 = require("@material-ui/core/styles");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    chooseDate: {
        marginTop: theme.spacing(-2),
    },
}); });
var ChildForm = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var classes = useStyles(props);
    var createChild = function () {
        var c = new legup_model_1.Child();
        if (props.parents) {
            c.setAddress(props.parents[0].getAddress());
        }
        return c;
    };
    var _s = react_1.default.useState(props.child ? props.child.copy() : createChild()), child = _s[0], setChild = _s[1];
    var _t = react_1.default.useState(!props.child || ((_a = props.child.getAddress()) === null || _a === void 0 ? void 0 : _a.isEmpty())
        || (!!((_b = props.parents) === null || _b === void 0 ? void 0 : _b.length) && ((_d = (_c = props.parents[0]) === null || _c === void 0 ? void 0 : _c.getAddress()) === null || _d === void 0 ? void 0 : _d.equals(props.child.getAddress())))), useParent1Address = _t[0], setUseParent1Address = _t[1];
    var _u = react_1.default.useState(props.child && !((_e = props.child.getAddress()) === null || _e === void 0 ? void 0 : _e.isEmpty())
        && (((_f = props.parents) === null || _f === void 0 ? void 0 : _f.length) > 1) && ((_h = (_g = props.parents[1]) === null || _g === void 0 ? void 0 : _g.getAddress()) === null || _h === void 0 ? void 0 : _h.equals(props.child.getAddress()))), useParent2Address = _u[0], setUseParent2Address = _u[1];
    var _v = react_1.default.useState(((_j = props.child) === null || _j === void 0 ? void 0 : _j.getId()) && !((_k = props.child.getFirstName()) === null || _k === void 0 ? void 0 : _k.length) && !((_l = props.child.getLastName()) === null || _l === void 0 ? void 0 : _l.length)), noName = _v[0], setNoName = _v[1];
    var _w = react_1.default.useState(), validation = _w[0], setValidation = _w[1];
    var _x = react_1.default.useState(), requiredAlert = _x[0], setRequiredAlert = _x[1];
    var _y = react_1.default.useState(false), toggledAddress = _y[0], setToggledAddress = _y[1];
    react_1.default.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var c = props.child ? props.child.copy() : createChild();
        setChild(props.child ? props.child.copy() : createChild());
        setNoName(((_a = props.child) === null || _a === void 0 ? void 0 : _a.getId()) && !((_b = props.child.getFirstName()) === null || _b === void 0 ? void 0 : _b.length) && !((_c = props.child.getLastName()) === null || _c === void 0 ? void 0 : _c.length));
        if (!toggledAddress) {
            var up1a = (!props.child || ((_d = props.child.getAddress()) === null || _d === void 0 ? void 0 : _d.isEmpty())
                || (!!((_e = props.parents) === null || _e === void 0 ? void 0 : _e.length) && ((_g = (_f = props.parents[0]) === null || _f === void 0 ? void 0 : _f.getAddress()) === null || _g === void 0 ? void 0 : _g.equals(props.child.getAddress()))));
            var up2a = (props.child && !((_h = props.child.getAddress()) === null || _h === void 0 ? void 0 : _h.isEmpty())
                && (((_j = props.parents) === null || _j === void 0 ? void 0 : _j.length) > 1) && ((_l = (_k = props.parents[1]) === null || _k === void 0 ? void 0 : _k.getAddress()) === null || _l === void 0 ? void 0 : _l.equals(props.child.getAddress())));
            if (up1a && ((_m = props.parents) === null || _m === void 0 ? void 0 : _m.length)) {
                c.setAddress(props.parents[0].getAddress());
            }
            else if (up2a && (((_o = props.parents) === null || _o === void 0 ? void 0 : _o.length) > 1)) {
                c.setAddress(props.parents[1].getAddress());
            }
            setUseParent1Address(up1a);
            setUseParent2Address(up2a);
        }
        setChild(c);
    }, [props.child, props.parents]);
    var saveChild = function () {
        var _a, _b, _c;
        if ((child === null || child === void 0 ? void 0 : child.getId()) && !useParent1Address && !useParent2Address) {
            var regexPattern = /^(\d{5})$/;
            if (!child.getLastName()
                || !regexPattern.test(child.getAddress().getPostalCode())
                || !((_a = child.getAddress().getStreetAddress1()) === null || _a === void 0 ? void 0 : _a.length)
                || !((_b = child.getAddress().getCity()) === null || _b === void 0 ? void 0 : _b.length)
                || !((_c = child.getAddress().getState()) === null || _c === void 0 ? void 0 : _c.length)) {
                setValidation(true);
                setRequiredAlert(true);
                return;
            }
        }
        if (props.onSave) {
            props.onSave(child);
        }
    };
    var onAddressChange = function (address, field) {
        var c = child.copy();
        c.setAddress(address);
        setChild(c);
        setUseParent1Address(false);
        setUseParent2Address(false);
        if (props.onChange) {
            props.onChange(c, field);
        }
    };
    var onChangeChildFirstName = function (e) {
        var c = child.copy();
        c.setFirstName(e.target.value);
        setChild(c);
        if (props.onChange) {
            props.onChange(c, e.target.name);
        }
    };
    var onChangeChildLastName = function (e) {
        var c = child.copy();
        c.setLastName(e.target.value);
        setChild(c);
        if (props.onChange) {
            props.onChange(c, e.target.name);
        }
    };
    var onFormatChildFirstName = function (e) {
        var c = child.copy();
        c.setFirstName(e.target.value.trim());
        setChild(c);
    };
    var onFormatChildLastName = function (e) {
        var c = child.copy();
        c.setLastName(e.target.value.trim());
        setChild(c);
    };
    var onBirthdayChange = function (date) {
        var c = child.copy();
        c.setBirthDate(date);
        c.setBorn(date > new Date() ? "expecting" : "born");
        setChild(c);
        if (props.onChange) {
            props.onChange(c, "birth_date");
        }
    };
    var onTryingCheck = function (e) {
        var c = child.copy();
        if (e.target.checked) {
            c.setBorn("trying");
            c.setBirthDate(undefined);
        }
        else {
            c.setBorn("born");
            c.setBirthDate(new Date());
        }
        setChild(c);
        if (props.onChange) {
            props.onChange(c, "trying");
        }
    };
    var onNoNameCheck = function (e) {
        if (e.target.checked) {
            var c = child.copy();
            c.setFirstName(undefined);
            c.setLastName(undefined);
            setChild(c);
        }
        setNoName(e.target.checked);
    };
    var onGenderChange = function (e) {
        var c = child.copy();
        var gender = ((e.target.value === "male") || (e.target.value === "female") || (e.target.value === "other")) ? e.target.value : undefined;
        c.setGender(gender);
        setChild(c);
        if (props.onChange) {
            props.onChange(c, "gender");
        }
    };
    var onUseParentAddressChange = function (e, idx) {
        var c = child.copy();
        if (!e.target.checked) {
            c.setAddress(new legup_model_1.Address());
        }
        else {
            c.setAddress(props.parents[idx].getAddress());
        }
        setChild(c);
        setUseParent1Address((idx === 0) ? e.target.checked : false);
        setUseParent2Address((idx === 1) ? e.target.checked : false);
        setToggledAddress(true);
        if (props.onChange) {
            props.onChange(c, "sameaddress");
        }
    };
    var errorStreet = false;
    var errorCity = false;
    var errorState = false;
    var errorzip = false;
    if (props.validation || validation) {
        if (!useParent1Address && !useParent2Address) {
            var regexPattern = /^(\d{5})$/;
            errorzip = !regexPattern.test(child.getAddress().getPostalCode());
            errorStreet = !((_m = child.getAddress().getStreetAddress1()) === null || _m === void 0 ? void 0 : _m.length);
            errorCity = !((_o = child.getAddress().getCity()) === null || _o === void 0 ? void 0 : _o.length);
            errorState = !((_p = child.getAddress().getState()) === null || _p === void 0 ? void 0 : _p.length);
        }
    }
    var promptParent2Address = (((_q = props.parents) === null || _q === void 0 ? void 0 : _q.length) > 1) && ((_r = props.parents[1].getEmail()) === null || _r === void 0 ? void 0 : _r.length)
        && !props.parents[1].getAddress().isEmpty()
        && (!props.parents[0].getAddress().equals(props.parents[1].getAddress()));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 2 },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { checked: noName, onChange: onNoNameCheck, disabled: props.readOnly, color: "primary" }), label: strings_1.default.childForm.noName })),
            !props.noGender && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(FormControl_1.default, null,
                    react_1.default.createElement(InputLabel_1.default, { id: "select-gender" }, strings_1.default.childForm.gender),
                    react_1.default.createElement(Select_1.default, { labelId: "gender", id: "gender", name: "gender", fullWidth: true, disabled: props.readOnly, value: child.gender || "none", onChange: onGenderChange },
                        react_1.default.createElement(MenuItem_1.default, { value: "none" }, strings_1.default.childForm.noGender),
                        react_1.default.createElement(MenuItem_1.default, { value: "male" }, strings_1.default.childForm.male),
                        react_1.default.createElement(MenuItem_1.default, { value: "female" }, strings_1.default.childForm.female),
                        !props.disallowOther && react_1.default.createElement(MenuItem_1.default, { value: "other" }, strings_1.default.childForm.otherGender))))),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(LimitTextField_1.LimitTextField, { id: "child_first_name", name: "first_name", variant: "outlined", size: "small", fullWidth: true, label: strings_1.default.childForm.firstName, value: child.first_name, disabled: props.readOnly || noName, limit: 128, showCount: false, onChange: onChangeChildFirstName, onBlur: onFormatChildFirstName })),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(LimitTextField_1.LimitTextField, { id: "child_last_name", name: "last_name", variant: "outlined", size: "small", fullWidth: true, label: strings_1.default.childForm.lastName, value: child.last_name, disabled: props.readOnly || noName, limit: 128, showCount: false, onChange: onChangeChildLastName, onBlur: onFormatChildLastName })),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { checked: child.getBorn() === "trying", onChange: onTryingCheck, disabled: props.readOnly, color: "primary" }), label: strings_1.default.childForm.trying })),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12, className: classes.chooseDate },
                react_1.default.createElement(ChooseDate_1.ChooseDate, { title: strings_1.default.childForm.birthDate, date: child.getBirthDate() || new Date(), yearMin: 18, yearMax: 2, readOnly: (child.getBorn() === "trying") || props.readOnly, onChange: onBirthdayChange, titleWidth: 200 })),
            !props.noAddress && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Grid_1.default, { container: true },
                        react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                            react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { checked: useParent1Address, onChange: function (e) { return onUseParentAddressChange(e, 0); }, value: "parent-address", name: "parent-address", color: "primary", disabled: props.readOnly }), label: strings_1.default.childForm.useParent1Address })),
                        promptParent2Address && react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                            react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { checked: useParent2Address, onChange: function (e) { return onUseParentAddressChange(e, 1); }, value: "parent-address", name: "parent-address", color: "primary", disabled: props.readOnly }), label: strings_1.default.childForm.useParent2Address })))),
                !useParent1Address && !useParent2Address && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Address_1.Address, { address: child.address, name: "child", readOnly: props.readOnly, onChange: onAddressChange, errorStreetAddress: errorStreet, errorState: errorState, zipcodeValidationError: errorzip, errorCity: errorCity })))),
            !!props.saveButton &&
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Button_1.default, { variant: "contained", color: "secondary", fullWidth: true, onClick: saveChild }, !(child === null || child === void 0 ? void 0 : child.getId())
                        ? strings_1.default.childForm.buttonAdd
                        : strings_1.default.childForm.buttonSave))),
        react_1.default.createElement(Alert_1.Alert, { title: strings_1.default.requiredFields.title, description: strings_1.default.requiredFields.message, open: requiredAlert, onClose: function () { return setRequiredAlert(false); } })));
};
exports.ChildForm = ChildForm;
